import React from "react"
import Title from "./title"

const Heading = props => {
  return (
    <>
      {props.caption && (
        <span className="caption animTxt">
          <span>{props.caption}</span>
        </span>
      )}
      {props.title && <Title heading={props.heading} text={props.title} />}
      {props.description && (
        <div className="description animTxt animTxt_3">{props.description}</div>
      )}
    </>
  )
}

export default Heading
